import { atom } from 'nanostores'

import type { LangCode } from '@/services/schemas'

const defaultLang = (import.meta.env.VITE_DEFAULT_LANG as LangCode) || 'en'

export const $language = atom<LangCode>(defaultLang)
